// Libs
import { createAsyncThunk } from '@reduxjs/toolkit';
// Others
import {
  CHANGE_STATUS_INVOICE,
  CREATE_INVOICE,
  DELETE_INVOICE,
  GET_DETAIL_INVOICE,
  GET_LIST_INVOICE,
  SEND_MAIL_INVOICE,
  UPDATE_INVOICE,
} from '~/utils/constants/actionType';
import invoiceApi from '~/apis/invoice';
import { IBodyUpdate } from '~/utils/interface/common';
import { IChangeStatusInvoice, IParamQueryInvoice, IQueryDetailInvoice } from '~/utils/interface/invoice';

export const getListInvoice = createAsyncThunk(
  GET_LIST_INVOICE,
  async (params: IParamQueryInvoice, { rejectWithValue }) => {
    try {
      const resp = await invoiceApi.getListInvoice(params);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getDetailInvoice = createAsyncThunk(
  GET_DETAIL_INVOICE,
  async (query: IQueryDetailInvoice, { rejectWithValue }) => {
    try {
      const resp = await invoiceApi.getDetailInvoice(query);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const createInvoice = createAsyncThunk(CREATE_INVOICE, async (body: FormData, { rejectWithValue }) => {
  try {
    const resp = await invoiceApi.createInvoice(body);
    return resp.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const updateInvoice = createAsyncThunk(
  UPDATE_INVOICE,
  async (params: IBodyUpdate<FormData>, { rejectWithValue }) => {
    try {
      const resp = await invoiceApi.updateInvoice(params);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const deleteInvoice = createAsyncThunk(DELETE_INVOICE, async (id: string, { rejectWithValue }) => {
  try {
    const resp = await invoiceApi.deleteInvoice(id);
    return resp.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const sendMailInvoice = createAsyncThunk(
  SEND_MAIL_INVOICE,
  async (params: IBodyUpdate<FormData>, { rejectWithValue }) => {
    try {
      const resp = await invoiceApi.sendMailInvoice(params);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const changeStatusInvoice = createAsyncThunk(
  CHANGE_STATUS_INVOICE,
  async (params: IBodyUpdate<IChangeStatusInvoice>, { rejectWithValue }) => {
    try {
      const resp = await invoiceApi.changeStatusInvoice(params);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
